import MainApi from "../../../MainApi";
import { suggested_items_stores } from "../../../ApiRoutes";
import { useQuery } from "react-query";
import { onSingleErrorResponse } from "../../../api-error-response/ErrorResponses";
import { safeGetFromLocalStorage } from "../../../../helper-functions/safeJSONParse";

const getData = async (key) => {
  if (key !== "") {
    const { data } = await MainApi.get(`${suggested_items_stores}?name=${key}`);
    return data;
  }
};

export default function useGetItemOrStore(key) {
  const moduleId = typeof window !== "undefined" ? safeGetFromLocalStorage("module", null)?.id : null;
  return useQuery(["item-and-store-suggestions", key, moduleId], () => getData(key), {
    enabled: false,
    onError: onSingleErrorResponse,
  });
}
